import { CalendarDate, Day } from "@gemma/dates";
import { DateRelativeTo, EntryPeriod } from "@gemma/utils";

import { getTimesheetDisabledDates } from "./getTimesheetDisabledDates";

export function timesheetDisabledDates() {
  return {
    computed: {
      timesheetDisabledDates(
        //
        this: {
          recruitmentAgencySettings: {
            defaults: {
              dateRelativeTo: DateRelativeTo;
              timesheetWeekStartsOn: Day;
            };
          };
          contractor?: {
            entryPeriod: EntryPeriod;
            start?: Readonly<CalendarDate>;
            end?: Readonly<CalendarDate>;
          };
          selectedContractor?: {
            entryPeriod: EntryPeriod;
            start?: Readonly<CalendarDate>;
            end?: Readonly<CalendarDate>;
          };
        }
      ) {
        const contractor = this.contractor || this.selectedContractor;
        if (contractor) {
          const timesheetDisabledDates = getTimesheetDisabledDates.call(this, contractor);
          return timesheetDisabledDates;
        }
      },
    },
  };
}
